import { render } from "./ThongTinLenhTuyChon.vue?vue&type=template&id=906160ee&scoped=true"
import script from "./ThongTinLenhTuyChon.vue?vue&type=script&lang=js"
export * from "./ThongTinLenhTuyChon.vue?vue&type=script&lang=js"

import "./ThongTinLenhTuyChon.vue?vue&type=style&index=0&id=906160ee&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-906160ee"]])

export default __exports__